module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c429a0c638d1138c1f0b6ddac3491bad.png";